<script>
import { ref, onMounted, toRefs, watch, computed, reactive, onBeforeUpdate } from "vue";
import CTAButton from "../components/CTAButton.vue";
import Form from "../components/Form.vue";
import { useTransferEffect } from "../functions";
import { useScrollEffect } from "../functions";
// import * as THREE from "three";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

export default {
	components: {
		CTAButton,
		Form,
	},
	props: ["windowWidth", "windowHeight", "scrollTop"],
	setup(props) {
		const { windowWidth, windowHeight, scrollTop } = toRefs(props);

		const container = ref(null);
		const title = ref(null);
		const video = ref(null);
		const mask = ref(null);
		const transitions = ref(null);
		const selectorText = ref(null);
		const images = ref([]);
		const previous = ref(null);
		const next = ref(null);
		const canvasRef = ref(null);
		const formMask = ref(null);

		const containerHeight = ref(0);
		const nowCar = ref(0);
		const turns = ref(0);
		const time = ref([0, 0, 0]);
		const isAnimated = ref(true);
		const isTiming = ref(false);

		const nextCar = computed(() => {
			return nowCar.value > 1 ? 0 : nowCar.value + 1;
		});
		const preCar = computed(() => {
			return nowCar.value < 1 ? 2 : nowCar.value - 1;
		});

		const text = reactive({
			car: ["Gran Coupé", "Coupé", "Convertible"],
			alt: [
				"G26全新BMW 4系列Gran Coupé豪華四門跑車",
				"G23全新BMW 4系列Coupé豪華雙門跑車",
				"G22全新BMW 4系列Convertible豪華敞篷跑車",
			],
			chName: ["豪華四門跑車", "豪華雙門跑車", "豪華敞篷跑車"],
			formTitle: ["預約賞車", "預約賞車", "預約賞車"],
			intro: ["鋒格自成", "誰與爭鋒", "恣意馭風"],
			src: [
				"#form",
				"https://event.bmw.com.tw/campaign/2020/4series-coupe/official/?utm_source=eventsite&utm_medium=button&utm_campaign=4gc",
				"https://www.bmw.com.tw/zh/all-models/4-series/convertible/2020/bmw-4-series-convertible-highlights.html",
			],
		});
		const imgSrc = reactive({
			pc: [
				require("../assets/Gran_Coupé.jpg"),
				require("../assets/Coupé.jpg"),
				require("../assets/Convertible.jpg"),
			],
			mobile: [
				require("../assets/Gran_Coupé_mobile.jpg"),
				require("../assets/Coupé_mobile.jpg"),
				require("../assets/Convertible_mobile.jpg"),
			],
		});
		const videoSrc = reactive({
			pc: require("../assets/THE 4 imagination.mp4"),
			mobile: require("../assets/THE 4 imagination_mobile.mp4"),
		});
		const gaData = reactive({
			gaData1: [
				{
					event_type: "click",
					event_category: "testdrive",
					event_label: "testdrive_4gc",
				},
				{
					event_type: "click",
					event_category: "info",
					event_label: "info_4coupe",
				},
				{
					event_type: "click",
					event_category: "info",
					event_label: "info_4convertible",
				},
			],
			gaData2: [
				{},
				{
					event_type: "click",
					event_category: "testdrive",
					event_label: "testdrive_4coupe",
				},
				{
					event_type: "click",
					event_category: "testdrive",
					event_label: "testdrive_4convertible",
				},
			],
		});

		const innerHeight = computed(() => {
			return scrollTop.value - containerHeight.value;
		});
		const progress = computed(() => {
			return ((time.value[nowCar.value] * 1000) / duration) * 100;
		});
		const isDouble = computed(() => {
			return nowCar.value === 0 ? false : true;
		});

		let timer = null;
		let duration = 7000;

		const carDisplay = (instruction) => {
			isAnimated.value = false;
			time.value = [0, 0, 0];
			if (instruction === "next") {
				turns.value = 0;
			}
			if (instruction === "next" || instruction === "countnext") {
				handleDisplay.transition(nextCar.value);
				if (nowCar.value >= 2) {
					nowCar.value = 0;
				} else {
					nowCar.value++;
				}
			} else {
				turns.value = 0;
				handleDisplay.transition(preCar.value);
				if (nowCar.value <= 0) {
					nowCar.value = 2;
				} else {
					nowCar.value--;
				}
			}
		};
		const timeCount = () => {
			timer = setInterval(() => {
				if (time.value[nowCar.value] * 1000 < duration) {
					isAnimated.value = true;
					time.value[nowCar.value]++;
				} else {
					isTiming.value = false;
					turns.value++;
					carDisplay("countnext");
					isTiming.value = true;
				}
			}, 1000);
		};

		const maskCoeff = useScrollEffect(
			1.1 * windowHeight.value,
			1.4 * windowHeight.value,
			-0.5,
			1.1
		);
		const titleCoeff = useScrollEffect(
			2 * windowHeight.value - 150,
			2 * windowHeight.value,
			-0.5,
			1.1
		);
		const smTransformCoeff = useScrollEffect(
			2 * windowHeight.value,
			2.5 * windowHeight.value,
			0,
			-50
		);
		const selectorTextCoeff = computed(() => {
			return useScrollEffect(4 * windowHeight.value, 4.3 * windowHeight.value, 1.1, -0.5);
		});
		const formMaskCoeff = useScrollEffect(
			5 * windowHeight.value - 150,
			5 * windowHeight.value,
			-0.5,
			1.1
		);

		const imgRef = (el) => {
			if (el) {
				images.value.push(el);
			}
		};

		let handleDisplay = null;
		const handleTransitions = () => {
			handleDisplay = new useTransferEffect(
				{
					parent: transitions.value,
					intensity: transitions.value.dataset.intensity || undefined,
					speed: transitions.value.dataset.speed || undefined,
					easing: transitions.value.dataset.easing || undefined,
					displacementImage: transitions.value.dataset.displacement,
				},
				canvasRef.value,
				"image",
				images.value[0],
				images.value[1],
				images.value[2]
			);
			// handleDisplay.transition(0);
		};
		const textHandleTransition = (val) => {
			if (isTiming.value) {
				turns.value = 0;
				nowCar.value = val;
				isAnimated.value = false;
				time.value = [0, 0, 0];
				handleDisplay.transition(nowCar.value);
			}
		};

		const xDown = ref(null);
		const yDown = ref(null);

		const getTouches = (evt) => {
			return evt.touches || evt.originalEvent.touches;
		};

		const handleTouchStart = (evt) => {
			const firstTouch = getTouches(evt)[0];
			xDown.value = firstTouch.clientX;
			yDown.value = firstTouch.clientY;
		};

		const handleTouchMove = (evt) => {
			if (!xDown.value || !yDown.value) {
				return;
			}

			const xUp = evt.touches[0].clientX;
			const yUp = evt.touches[0].clientY;

			const xDiff = xDown.value - xUp;
			const yDiff = yDown.value - yUp;

			if (Math.abs(xDiff) > Math.abs(yDiff)) {
				/*most significant*/
				if (xDiff > 0) {
					carDisplay("next");
				} else {
					carDisplay("previous");
				}
			}
			/* reset values */
			xDown.value = null;
			yDown.value = null;
		};

		const handleChangeCode = (val) => {
			nowCar.value = val;
			handleDisplay.transition(nowCar.value);
		};

		onMounted(() => {
			containerHeight.value = container.value.getBoundingClientRect().top;
			window.addEventListener("resize", () => {
				containerHeight.value = container.value.getBoundingClientRect().top;
			});
			if (images.value[0].complete) {
				console.log("image complete");
				handleTransitions();
			} else {
				console.log("image onload");
				images.value[0].onload = handleTransitions;
			}
		});

		onBeforeUpdate(() => {
			images.value = [];
		});

		// const videoCount = ref(0)
		const isVideoTimeing = ref("not scroll");
		let videoTimer = null;
		const videoTimeCount = () => {
			videoTimer = setTimeout(() => {
				gsap.to(document.body, {
					scrollTo: {
						y: "#imagination_title",
						offset: "0",
						autoKill: true,
					},
					ease: "power2.inOut",
					duration: 1.5,
				});
			}, 14000);
		};

		gsap.registerPlugin(ScrollToPlugin);

		watch(isVideoTimeing, (nv, ov) => {
			if (nv === "not scroll") {
				clearTimeout(videoTimer);
				videoTimer = null;
			} else {
				if (nv !== ov) {
					clearTimeout(videoTimer);
					videoTimer = null;
					videoTimeCount();
				} else {
					videoTimeCount();
				}
			}
		});

		watch(
			() => innerHeight.value,
			(nv, ov) => {
				if (nv > windowHeight.value && nv < 2 * windowHeight.value) {
					isVideoTimeing.value = nv;
				} else {
					isVideoTimeing.value = "not scroll";
				}
				if (nv > 1.1 * windowHeight.value) {
					// mask.value.style.opacity = `${nv * maskCoeff.a +
					// 	maskCoeff.b}`;
				} else {
					// mask.value.style.opacity = 0;
				}

				if (nv > 2 * windowHeight.value - 150) {
					title.value.style.opacity = `${nv * titleCoeff.a + titleCoeff.b}`;
				} else {
					// title.value.style.opacity = 0;
				}

				if (nv > 2 * windowHeight.value && nv < 2.5 * windowHeight.value) {
					title.value.style.transform = `translateY(${nv * smTransformCoeff.a +
						smTransformCoeff.b}px)`;
				} else if (nv > 2.5 * windowHeight.value) {
					// title.value.style.transform = "translate(0px)";
				}

				if (nv > 3.5 * windowHeight.value || nv <= 0) {
					video.value.pause();
				} else {
					video.value.play();
				}

				if (nv > 5 * windowHeight.value - 150) {
					formMask.value.style.opacity = `${nv * formMaskCoeff.a + formMaskCoeff.b}`;
				} else {
					// formMask.value.style.opacity = 0;
				}

				if (nv > 4 * windowHeight.value) {
					selectorText.value.style.opacity = `${nv * selectorTextCoeff.value.a +
						selectorTextCoeff.value.b}`;
				} else {
					selectorText.value.style.opacity = 1;
				}

				if (nv > 3.3 * windowHeight.value && nv < 4.5 * windowHeight.value) {
					isTiming.value = true;
				} else {
					isTiming.value = false;
				}
			}
		);

		watch(
			() => isTiming.value,
			(nv, ov) => {
				// console.log(nv);
				if (nv) {
					timeCount();
				} else {
					clearInterval(timer);
					isAnimated.value = false;
					time.value = [0, 0, 0];
				}
			}
		);

		// watch(nowCar, (nv, ov) => {
		// 	console.log(gaData.gaData2[nowCar.value]);
		// });

		return {
			windowWidth,
			container,
			videoSrc,
			video,
			mask,
			title,
			transitions,
			selectorText,
			imgRef,
			imgSrc,
			canvasRef,
			next,
			previous,
			text,
			nowCar,
			preCar,
			nextCar,
			carDisplay,
			progress,
			isAnimated,
			isDouble,
			gaData,
			formMask,
			handleChangeCode,
			handleTouchStart,
			handleTouchMove,
			textHandleTransition,
		};
	},
};
</script>

<template>
	<section id="imagination" ref="container">
		<div class="sticky-wrapper">
			<video
				id="story_video_c3"
				:src="windowWidth > 768 ? videoSrc.pc : videoSrc.mobile"
				ref="video"
				loop
				muted
				autoplay
				playsinline
				preload="auto"
			></video>
			<div class="mask" ref="mask"></div>
		</div>
	</section>
	<section id="imagination_title">
		<div class="sticky-wrapper">
			<div class="title_main text_en_thin" ref="title">
				<h2>Enjoy Every Edge</h2>
				<h2 class="title_sub text_ch_medium shine">鋒芒隨行</h2>
			</div>
		</div>
	</section>
	<section id="display">
		<div
			class="img-wrapper sticky-wrapper"
			data-displacement="diamond.jpg"
			data-intensity="0.4"
			data-speed="1.2"
			data-easing="power3.inOut"
			ref="transitions"
		>
			<img
				v-for="(item, idx) in text.alt"
				:src="windowWidth > 800 ? imgSrc.pc[idx] : imgSrc.mobile[idx]"
				:alt="item"
				:key="item"
				:ref="imgRef"
			/>
			<canvas ref="canvasRef"></canvas>
		</div>
		<div class="series_display" @touchstart="handleTouchStart" @touchmove="handleTouchMove">
			<div class="sticky-wrapper" ref="selectorText">
				<div class="selector">
					<div class="type">
						<div class="text-anim text-anim_left">
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_left pc"
									@click="textHandleTransition(0)"
									v-show="nowCar === 1"
								>
									{{ text.car[0] }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_left pc"
									@click="textHandleTransition(1)"
									v-show="nowCar === 2"
								>
									{{ text.car[1] }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_left mobile"
									@click="textHandleTransition(2)"
									v-show="nowCar === 0 || windowWidth <= 650"
								>
									{{ text.car[2] }}
									<div
										class="arrow_right hshake_right_sm"
										:style="{
											opacity: nowCar === 2 ? 1 : 0,
										}"
									></div>
								</div>
							</transition>
						</div>
						<div
							class="img-button left pc hshake_left"
							@click="carDisplay('previous')"
							ref="previous"
						></div>
						<div class="text-anim text-anim_center">
							<transition name="fade">
								<div
									class="type_name_en text_en_regular pc name_center"
									v-show="nowCar === 2"
								>
									{{ `THE 4 ${text.car[2]}` }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_regular pc name_center"
									v-show="nowCar === 1"
								>
									{{ `THE 4 ${text.car[1]}` }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_regular name_center mobile"
									@click="textHandleTransition(0)"
									v-show="nowCar === 0 || windowWidth <= 650"
								>
									{{ `${windowWidth > 650 ? "THE 4" : ""} ${text.car[0]}` }}
									<div
										class="arrow_right hshake_right_sm"
										:style="{
											opacity: nowCar === 0 ? 1 : 0,
										}"
									></div>
								</div>
							</transition>
						</div>
						<div
							class="img-button right pc hshake_right"
							@click="carDisplay('next')"
							ref="next"
						></div>
						<div class="text-anim text-anim_right">
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_left pc"
									@click="textHandleTransition(2)"
									v-show="nowCar === 1"
								>
									{{ text.car[2] }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_left pc"
									@click="textHandleTransition(0)"
									v-show="nowCar === 2"
								>
									{{ text.car[0] }}
								</div>
							</transition>
							<transition name="fade">
								<div
									class="type_name_en text_en_thin name_right mobile"
									@click="textHandleTransition(1)"
									v-show="nowCar === 0 || windowWidth <= 650"
								>
									{{ text.car[1] }}
									<div
										class="arrow_right hshake_right_sm"
										:style="{
											opacity: nowCar === 1 ? 1 : 0,
										}"
									></div>
								</div>
							</transition>
						</div>
					</div>
					<div class="name">
						<div class="bar pc">
							<svg xmlns="http://www.w3.org/2000/svg" width="929.69" height="2.531">
								<path
									data-name="Path 550"
									d="m832.174 429.192 29.053.132 29.053.1 58.106.2 116.211.245q58.106.159 116.211.127l116.211.08L1413.23 430l58.106-.04 29.053-.023 29.052-.061 116.211-.246 58.105-.2 29.053-.1 29.053-.133v-.77l-29.053-.134-29.053-.1-58.105-.2-116.211-.246-29.052-.061-29.053-.023-58.106-.04-116.211-.077-116.211.08q-58.106.058-116.211.126l-116.211.245-58.106.2-29.053.1-29.053.132z"
									transform="translate(-832.174 -427.542)"
									style="fill:#fff;opacity:.7"
								/>
							</svg>
						</div>
						<div class="bar mobile">
							<svg xmlns="http://www.w3.org/2000/svg" width="303.78" height="1">
								<path
									d="m832.174 428.194 9.493.052 9.493.039 18.986.078 37.973.1c12.658.042 25.315.034 37.973.05l37.973.031 37.973-.031 18.986-.016 9.493-.009 9.493-.024 37.973-.1 18.986-.079 9.493-.04 9.493-.053v-.3l-9.493-.053-9.493-.04-18.986-.079-37.973-.1-9.493-.024-9.493-.009-18.986-.016-37.973-.031-37.973.031c-12.658.015-25.315.008-37.973.05l-37.973.1-18.986.078-9.493.04-9.493.052z"
									transform="translate(-832.174 -427.542)"
									style="fill:#fff;opacity:.7"
								/>
							</svg>
						</div>
						<div class="car-switch">
							<p
								class="type_name_en text_en_regular mobile"
								:style="{ opacity: nowCar === 0 ? 1 : 0 }"
							>
								{{ `THE 4 ${text.car[0]}` }}
							</p>
							<p
								class="type_name_en text_en_regular mobile"
								:style="{ opacity: nowCar === 1 ? 1 : 0 }"
							>
								{{ `THE 4 ${text.car[1]}` }}
							</p>
							<p
								class="type_name_en text_en_regular mobile"
								:style="{ opacity: nowCar === 2 ? 1 : 0 }"
							>
								{{ `THE 4 ${text.car[2]}` }}
							</p>
						</div>
						<div class="bar mobile">
							<svg xmlns="http://www.w3.org/2000/svg" width="303.78" height="1">
								<path
									d="m832.174 428.194 9.493.052 9.493.039 18.986.078 37.973.1c12.658.042 25.315.034 37.973.05l37.973.031 37.973-.031 18.986-.016 9.493-.009 9.493-.024 37.973-.1 18.986-.079 9.493-.04 9.493-.053v-.3l-9.493-.053-9.493-.04-18.986-.079-37.973-.1-9.493-.024-9.493-.009-18.986-.016-37.973-.031-37.973.031c-12.658.015-25.315.008-37.973.05l-37.973.1-18.986.078-9.493.04-9.493.052z"
									transform="translate(-832.174 -427.542)"
									style="fill:#fff;opacity:.7"
								/>
							</svg>
						</div>
					</div>
					<div class="car-switch name_ch">
						<p
							class="type_name_ch text_ch_medium"
							:style="{ opacity: nowCar === 0 ? 1 : 0 }"
						>
							{{ text.chName[0] }}
						</p>
						<p
							class="type_name_ch text_ch_medium"
							:style="{ opacity: nowCar === 1 ? 1 : 0 }"
						>
							{{ text.chName[1] }}
						</p>
						<p
							class="type_name_ch text_ch_medium"
							:style="{ opacity: nowCar === 2 ? 1 : 0 }"
						>
							{{ text.chName[2] }}
						</p>
					</div>
				</div>
				<div class="button-wrapper">
					<!-- <p class="style_intro text_ch_medium">
                        {{ text.intro[nowCar] }}
                    </p> -->
					<div class="car-switch">
						<p
							class="style_intro text_ch_medium"
							:style="{ opacity: nowCar === 0 ? 1 : 0 }"
						>
							{{ text.intro[0] }}
						</p>
						<p
							class="style_intro text_ch_medium"
							:style="{ opacity: nowCar === 1 ? 1 : 0 }"
						>
							{{ text.intro[1] }}
						</p>
						<p
							class="style_intro text_ch_medium"
							:style="{ opacity: nowCar === 2 ? 1 : 0 }"
						>
							{{ text.intro[2] }}
						</p>
					</div>
					<CTAButton
						:progress="progress"
						:isAnimated="isAnimated"
						:isDouble="isDouble"
						:href1="text.src[nowCar]"
						:href2="'#form'"
						:GAData1="gaData.gaData1[nowCar]"
						:GAData2="gaData.gaData2[nowCar]"
						>預約賞車</CTAButton
					>
				</div>
				<div class="arrow_select">
					<div class="arrow_middle_left" @click="carDisplay('previous')"></div>
					<div class="arrow_middle_right" @click="carDisplay('next')"></div>
				</div>
			</div>
		</div>
		<Form @changeCode="handleChangeCode" :nowCar="nowCar">{{ text.formTitle[nowCar] }}</Form>
		<div class="form-mask" ref="formMask"></div>
	</section>
</template>

<style lang="sass" scoped>

#imagination
    // z-index: 62
    z-index: 54
    .sticky-wrapper
        width: 100%
        #story_video_c3
            width: 100%
            height: 100%
            object-fit: cover
        .mask
            position: relative
            width: 100%
            height: 100%
            top: -100%
            opacity: 0
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 16%, rgba(0, 0, 0, 0.77) 71%, #010b24 91%)


#imagination_title
    // z-index: 62
    z-index: 54
    .sticky-wrapper
        width: 100%
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        .title_main
            opacity: 0
            width: 100%
            // transform: translateY(50px)
            h2
                font-size: calc(4.6vw + 12.2px)
                letter-spacing: 4px
                text-align: center
            .title_sub
                width: 100%
                margin-top: 50px
                font-size: 3rem
                line-height: 3.54
                letter-spacing: 28.8px

#display
    // z-index: 15
    // z-index: 61
    z-index: 67
    background-color: #111
    .img-wrapper
        width: 100%
        overflow: hidden
        img
            display: none
        img, canvas
            position: absolute
            left: 50%
            bottom: 0
            transform: translate(-50%, 0)
            width: 100%
            height: 100%
            z-index: -1
    .series_display
        position: relative
        width: 100%
        z-index: 65
        .sticky-wrapper
            width: 100%
            // height: 100vh
            // .car-switch
            //     display: inline-block
            //     width: 33.3%
            //     height: 100%

    .form-mask
        position: absolute
        width: 100%
        opacity: 0
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.7) 6%, rgba(100, 0, 23, 0.62) 31%, rgba(1, 11, 36, 0.6) 95%)

.selector
    position: absolute
    left: 50%
    transform: translateX(-50%)
    // padding-top: 120px
    padding-top: 6.25%
    z-index: 200
    width: 90vw
    max-width: 1000px
    .type
        position: relative
        // display: flex
        // justify-content: center
        // align-items: center
        height: 60px
        margin: 0 auto
        padding: 0 calc((100% - 860px) / 2)
        .text-anim
            // position: absolute
            position: relative
            display: inline-block
            width: 180px
            height: 60px
            top: 55%
            vertical-align: top
            // transform: translateY(-50%)
            &.text-anim_left
                // left: 18%
                transform: translate(0%, -50%)
            &.text-anim_right
                // left: 82%
                transform: translate(0%, -50%)
            &.text-anim_center
                // left: 50%
                width: 450px
                transform: translate(0%, -50%)
        .img-button
            position: relative
            display: inline-block
            // position: absolute
            top: 50%
            transform: translate(0%, -50%)
            height: 6px
            width: 24px
            cursor: pointer
            user-select: none
            background-size: 24px 6px
            background-position: center center
            background-repeat: no-repeat
            vertical-align: top
            z-index: 50
            &.left
                // left: 25%
                background-image: url("~@/assets/arrow_left.png")
            &.right
                // left: 73%
                background-image: url("~@/assets/arrow_right.png")
        .type_name_en
            // display: inline-block
            position: absolute
            width: 100%
            height: 100%
            top: 50%
            transform: translateY(-50%)
            font-size: 2.3rem
            line-height: 60px
            letter-spacing: 0.63px
            text-align: center
            vertical-align: middle
            cursor: pointer
            user-select: none
            .arrow_right
                display: none
            &.name_center
                text-align: center
                width: 450px
                font-size: 4.5rem
                // line-height: 1.22
                letter-spacing: 0.68px
            &.name_left
                // text-align: right
                // padding-left: 0
                // padding-right: 2vw
            &.name_right
                // text-align: left
                // padding-right: 0
                // padding-left: 2vw
            &.only-mobile
                display: none
    .name
        position: relative
        margin: 0 auto
        margin-top: 15px
        max-width: 90%
        .bar
            position: absolute
            left: 50%
            transform: translateX(-50%)
            background-size: cover
            background-position: center
            background-repeat: no-repeat
            &.mobile
                display: none
    .car-switch
        &.name_ch
            p
                position: relative
                transition: 1s
            p:nth-child(2)
                transform: translateY(calc(-100% - 25px))
            p:nth-child(3)
                transform: translateY(calc(-200% - 50px))
    .type_name_ch
        width: 100%
        text-align: center
        margin-top: 25px
        font-size: 2.1rem
        line-height: 1.71
        letter-spacing: 4.2px
.button-wrapper
    position: absolute
    bottom: 0
    z-index: 200
    width: 100%
    text-align: center
    padding-bottom: calc(2vw + 22.4px + 10px)
    .car-switch
        p
            position: relative
            transition: 1s
        p:nth-child(1)
            transform: translateY(200%)
        p:nth-child(2)
            transform: translateY(100%)
        p:nth-child(3)
            // transform: translateY(-200%)
        .style_intro
            position: relative
            font-size: 2.1rem
            line-height: 2.5
            letter-spacing: 4.2px
    .CTA-button
        position: relative
        left: 50%
        top: 0%
        bottom: 0
        transform: translateX(-50%)
.arrow_select
    position: absolute
    height: 100%
    width: 100%
    .arrow_middle_left, .arrow_middle_right
        position: absolute
        width: 15px
        height: 47px
        top: 50%
        transform: translateY(-50%)
        background-size: contain
        background-position: center
        background-repeat: no-repeat
        cursor: pointer
        user-select: none
    .arrow_middle_left
        left: calc(4.6vw + 13.8px)
        background-image: url("~@/assets/arrow_middle_left.png")
    .arrow_middle_right
        right: calc(3.8vw + 17.4px)
        background-image: url("~@/assets/arrow_middle_right.png")

.fade-enter-active, .fade-leave-active
    transition: opacity 0.3s ease
.fade-enter-from, .fade-leave-to
    opacity: 0
.fade-enter-to, .fade-leave-from
    transition-delay: 0.3s
    opacity: 1

@media screen and (max-width: 1800px)
    #display
        .series_display
            .selector
                transform: translateX(-50%) scale(0.8)
            .arrow_select
                .arrow_middle_left, .arrow_middle_right
                    transform: translateY(-50%) scale(0.9)

@media screen and (max-width: 1600px)
    #display
        .series_display
            .sticky-wrapper
                .button-wrapper
                    .CTA-button
                        transform: translateX(-50%) scale(0.9)
@media screen and (max-width: 1440px)
    #display
        .series_display
            .sticky-wrapper
                .selector
                    // transform: translateX(-50%) scale(0.9)
                    transform: translateX(-50%) scale(0.7)
                    // transform-origin: center top
                .button-wrapper
                    transform: scale(0.9)
                    .CTA-button
                        transform: translateX(-50%) scale(1)
                    // transform-origin: center bottom
                .arrow_select
                    .arrow_middle_left, .arrow_middle_right
                        transform: translateY(-50%) scale(0.8)
@media screen and (max-width: 1200px)
    #display
        .series_display
            .sticky-wrapper
                .selector
                    // transform: translateX(-50%)
                    transform: translateX(-50%) scale(0.8)
                    padding-top: 8%
                    .type
                        padding: 0 calc((100% - 700px) / 2)
                        .text-anim
                            width: 150px
                            &.text-anim_left
                                // left: 24%
                            &.text-anim_right
                                // left: 76%
                            &.text-anim_center
                                width: 350px
                        .img-button
                            &.left
                                // left: 31%
                            &.right
                                // left: 67%
                        .type_name_en
                            // width: 100px
                            &.name_center
                                width: 350px
                    .name
                        .bar
                            transform: translateX(-50%) scale(0.8)
                .button-wrapper
                    .CTA-button
                        transform: translateX(-50%) scale(0.89)
                .arrow_select
                    .arrow_middle_left, .arrow_middle_right
                        transform: translateY(-50%) scale(0.7)

@media screen and (max-width: 800px)
    #imagination_title
        .sticky-wrapper
            .title_main
                h2
                    font-family: "BMWTypeNextLatinTT-Light", serif
                    line-height: 1.13
                    letter-spacing: 1.5px
                    &.title_sub
                        font-family: arudjingxiheipe1xg30_md, 微軟正黑體
                        margin-top: 15px
                        font-size: 1.8rem
                        line-height: 2.5
                        letter-spacing: 16px
    #display
        .img-wrapper
            &::before
                content: ""
                position: absolute
                display: block
                left: 0
                top: 0
                width: 100%
                height: 49.4%
                background-image: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 36%, #01081a 80%, #010b24 95%)
                z-index: 75
            &::after
                content: ""
                position: absolute
                display: block
                left: 0
                bottom: 0
                width: 100%
                height: 62.1%
                background-image: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 36%, rgba(0,3,10,0.5) 75%)
                z-index: 75
            canvas
                bottom: 60%
                transform: translate(-50%, 50%)
        .series_display
            .sticky-wrapper
                .selector
                    padding-top: 60px
                    transform: translateX(-50%) scale(0.8)
                    .type
                        padding: 0 calc((100% - 500px) / 2)
                        .text-anim
                            width: 100px
                            &.text-anim_left
                                // left: 18%
                            &.text-anim_right
                                // left: 82%
                            &.text-anim_center
                                width: 250px
                        .img-button
                            &.left
                                // left: 28%
                            &.right
                                // left: 70%
                        .type_name_en
                            font-size: 16px
                            // margin: 0 8px
                            &.name_center
                                width: 250px
                                font-size: 24px
                                margin: 0
                    .name
                        margin-top: 5px
                        .bar
                            transform: translateX(-50%) scale(0.64)
                .car-switch
                    &.name_ch
                        p:nth-child(2)
                            transform: translateY(calc(-100% - 15px))
                        p:nth-child(3)
                            transform: translateY(calc(-200% - 30px))
                .type_name_ch
                    margin-top: 15px
                    font-size: 20px
                    line-height: 2.3
                    letter-spacing: 2.4px
                .button-wrapper
                    transform: scale(0.8)
                    .style_intro
                        font-size: 20px
                        line-height: 3
                        letter-spacing: 2.8px
                    .CTA-button
                        transform: translateX(-50%) scale(0.875)
                .arrow_select
                    .arrow_middle_left, .arrow_middle_right
                        transform: translateY(-50%) scale(0.6)
@media screen and (max-width: 650px)
    #display
        .img-wrapper
            // &::before
            //     content: ""
            //     position: absolute
            //     display: block
            //     left: 0
            //     top: 0
            //     width: 100%
            //     height: 49.4%
            //     background-image: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 36%, #01081a 80%, #010b24 95%)
            //     z-index: 75
            // &::after
            //     content: ""
            //     position: absolute
            //     display: block
            //     left: 0
            //     bottom: 0
            //     width: 100%
            //     height: 62.1%
            //     background-image: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 36%, rgba(0,3,10,0.5) 75%)
            //     z-index: 75
            canvas
                bottom: 50%
        .series_display
            .sticky-wrapper
                .selector
                    transform: translateX(-50%)
                    padding-top: 100px
                    .only-mobile
                        display: block
                        position: absolute
                        width: 60px
                        height: 15px
                        top: 50%
                        left: 50%
                        transform: translate(-50%, -50%)
                    .mobile
                        display: block
                    .pc
                        display: none
                    .type
                        width: 250px
                        height: 15px
                        // padding: 0 calc((100% - 300px) / 2)
                        padding: 0
                        .text-anim
                            width: 90px
                            height: 15px
                            &.text-anim_left
                                // left: 75px
                            &.text-anim_right
                                width: 70px
                                // left: 256px
                            &.text-anim_center
                                width: 90px
                                // left: 168.5px
                                // width: 80px
                        .type_name_en
                            position: relative
                            display: inline-block
                            width: auto
                            height: 15px
                            text-align: center
                            vertical-align: middle
                            // padding: 0 1.7rem
                            font-size: 1.3rem
                            line-height: 15px
                            letter-spacing: 0.17px
                            .arrow_right
                                display: block
                                position: absolute
                                width: 10px
                                height: 12.7px
                                left: -5px
                                top: 50%
                                transform: translateY(-50%)
                                background-image: url("~@/assets/arrow_right.png")
                                background-size: 15px auto
                                background-position: center
                                background-repeat: no-repeat
                                transition: opacity 0.3s
                                transition-delay: 0.3s
                            &.name_center, &.name_right, &.name_left
                                width: 90px
                                font-size: 1.3rem
                                .arrow_right
                                    // left: 0px
                            &.name_right
                                width: 70px
                                .arrow_right
                                    left: 0px
                            &.pc
                                display: none
                    .name
                        position: relative
                        margin-top: 10px
                        height: 53px
                        .bar
                            width: 304px
                            transform: translateX(-50%) scale(1)
                        .mobile:nth-child(4)
                            transform: translate(-50%, -106px) scale(1)
                        .car-switch
                            p
                                position: relative
                                transition: 0.8s
                            p:nth-child(2)
                                transform: translateY(-100%)
                            p:nth-child(3)
                                transform: translateY(-200%)
                        .type_name_en
                            font-size: 2.5rem
                            line-height: 2.12
                            letter-spacing: 0.38px
                            text-align: center
                    .type_name_ch
                        margin: 15px 0px
                        font-size: 1.4rem
                        line-height: 2
                        letter-spacing: 2.8px
                .button-wrapper
                    padding-bottom: 75px
                    transform: scale(1)
                    .car-switch
                        position: relative
                        top: 20px
                    .style_intro
                        line-height: 3.95
                        font-size: 1.4rem
                    .CTA-button
                        transform: translateX(-50%) scale(0.6)
                .arrow_select
                    .arrow_middle_left, .arrow_middle_right
                        transform: translateY(-50%) scale(0.5)
@media screen and (max-height: 600px)
    #display
        .series_display
            .sticky-wrapper
                .selector
                    transform: translateX(-50%) scale(0.85)
                    padding-top: 70px
                    .name_ch
                        p
                            text-shadow: 1px 1px 1px rgba(0, 0, 0, 1)
                .button-wrapper
                    padding-bottom: 60px
</style>
